import { useLang } from '@/app/utils/useLang';
import { FC } from 'react';
import styled from './index.module.scss';

interface IProps {
    type?: string;
}

const JoinNow: FC<IProps> = ({}) => {
    const { t } = useLang('membersday.membersdayjoinus25');
    return (
        <div className={styled.JoinNow} id="power-share">
            <div className="join-header">
                <h5 className="title">{t('membersdayjoinus_header')}</h5>
                <p className="desc">{t('membersdayjoinus_desc')}</p>
            </div>
            <div className="join-content">
                <p className="content-text">{t('membersdayjoinus_content1')}</p>
                <p className="content-text">{t('membersdayjoinus_content2')}</p>
                <p className="content-text">{t('membersdayjoinus_content3')}</p>
            </div>
        </div>
    );
};

export default JoinNow;
